import {APIStatus, APIStatusType, PreferredPoint, PreferredPointType} from '@web/core/constants'

interface PreferredPointInfo {
    sequences: PreferredPointType[]
    apiStatus: APIStatusType
}

/**
 * TODO: 결제수단 앱 조회 응답의 소진 포인트 타입 확인 필요 (ENUM이라면 apigw 타입 수정 후 mapping 가능할 듯)
 * 결제수단 응답에서는 'POINT' | 'NAVERPOINT' 로 내려주므로 정제해서 매칭 필요
 */
export const getPreferredPoint = (seq?: string[]): PreferredPointInfo => {
    if (!seq || seq.length < 1) {
        return {
            sequences: [PreferredPoint.REWARD_POINT, PreferredPoint.CHARGE_POINT],
            apiStatus: APIStatus.REJECTED,
        }
    }
    if (seq[0] === 'POINT') {
        return {
            sequences: [PreferredPoint.REWARD_POINT, PreferredPoint.CHARGE_POINT],
            apiStatus: APIStatus.RESOLVED,
        }
    }
    return {
        sequences: [PreferredPoint.CHARGE_POINT, PreferredPoint.REWARD_POINT],
        apiStatus: APIStatus.RESOLVED,
    }
}
